/** Light colour wash (~8% alpha). Row tints, tracking dots, kanban fills. */
export const COLOR_ALPHA_LIGHT = 0.08

/** Medium colour wash (~12% alpha). Category pills, tag backgrounds. */
export const COLOR_ALPHA_MEDIUM = 0.12

/** Strong colour wash (~33% alpha). Icon glyphs on tinted dropdown rows. */
export const COLOR_ALPHA_STRONG = 0.33

/** Text on full-opacity chips. */
export const COLOR_CHIP_TEXT = '#FFFFFF'

/** Neutral fallback when a settings row has no colour set. */
export const DEFAULT_COLOR = '#9A968D'

/** Default colour for newly created settings rows. */
export const DEFAULT_SETTINGS_COLOR = '#0096C7'
